export const s3FixtureReviewTitle = 'S3 stylefix replay';

export const localFixtureSessionPrefix = 'fixture-local-';

export const CHUNK_LINE_COUNT_MIN = 20;
export const CHUNK_LINE_COUNT_MAX = 200;

export const TRANSCRIPT_REVIEW_PROPOSAL_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  STALE: 'STALE',
  FAILED: 'FAILED',
} as const;

export type TTranscriptReviewProposalStatus =
  (typeof TRANSCRIPT_REVIEW_PROPOSAL_STATUS)[keyof typeof TRANSCRIPT_REVIEW_PROPOSAL_STATUS];

export type TTranscriptReviewProposalDecision = 'ACCEPTED' | 'REJECTED';

export const TRANSCRIPT_REVIEW_PROPOSAL_SOURCE = {
  FIXTURE: 'FIXTURE',
  LLM: 'LLM',
  CHAT: 'CHAT',
} as const;

export type TTranscriptReviewProposalSource =
  (typeof TRANSCRIPT_REVIEW_PROPOSAL_SOURCE)[keyof typeof TRANSCRIPT_REVIEW_PROPOSAL_SOURCE];

export const TRANSCRIPT_REVIEW_SESSION_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHING: 'PUBLISHING',
  PUBLISHED: 'PUBLISHED',
} as const;

export type TTranscriptReviewSessionStatus =
  (typeof TRANSCRIPT_REVIEW_SESSION_STATUS)[keyof typeof TRANSCRIPT_REVIEW_SESSION_STATUS];
